var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8491 20.1511L17.242 15.5441C18.327 14.1061 18.9781 12.3241 18.9781 10.3881C18.9781 5.65207 15.124 1.79907 10.389 1.79907C5.65305 1.80007 1.80005 5.65307 1.80005 10.3891C1.80005 15.1241 5.65305 18.9781 10.389 18.9781C12.324 18.9781 14.107 18.3271 15.545 17.2421L20.1521 21.8491C20.386 22.0831 20.6931 22.2001 21 22.2001C21.307 22.2001 21.614 22.0831 21.8491 21.8481C22.3171 21.3801 22.3171 20.6201 21.8491 20.1511ZM4.20005 10.3891C4.20005 6.97607 6.97605 4.20007 10.389 4.20007C13.801 4.20007 16.577 6.97607 16.577 10.3881C16.577 13.8001 13.801 16.5761 10.389 16.5761C6.97605 16.5771 4.20005 13.8011 4.20005 10.3891Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchMono);
export default __webpack_public_path__ + "static/media/icon-search-mono.88f465229383674a1b918fba1b6c214a.svg";
export { ForwardRef as ReactComponent };